// extracted by mini-css-extract-plugin
export default {"buttons":"FormButtons_buttons__MZL4-","spinner":"FormButtons_spinner__xuWeo","spin":"FormButtons_spin__BG8Bw"};